import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { useFormik, FormikProps } from 'formik';
import { CreateShopFormValues } from 'components/Types/Tenant/shop.type';

interface FieldType {
  id: keyof CreateShopFormValues;
  label: string;
  required?: boolean;
  disabled?: boolean;
}

interface FormikInputProps {
  field: FieldType;
  formik: FormikProps<CreateShopFormValues>;
  onChangeCustom?: (value: string) => void;
}

const FormikInput: React.FC<FormikInputProps> = ({ field, formik, onChangeCustom }) => {
  const { id, label, required, disabled } = field;
  const error = formik.touched[id] && formik.errors[id];

  return (
    <FormGroup>
      <Label for={id} className="fw-bold">
        {label}
      </Label>
      <input
        id={id}
        name={id}
        type="text"
        className={`form-control${error ? ' is-invalid' : ''}`}
        value={(formik.values[id] as string) || ''}
        onChange={(e) => {
          const val = e.target.value;
          if (onChangeCustom) onChangeCustom(val);
          else formik.handleChange(e);
        }}
        onBlur={formik.handleBlur}
        placeholder={label}
        required={required}
        disabled={disabled}
        autoComplete="off"
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </FormGroup>
  );
};

export default FormikInput;
